export function setLeadOnly(){
    window.objOSGlobal.requestBodyValues.callback = true;
    window.objOSGlobal.requestBodyValues.IsLeadOnly = true;
    window.objOSGlobal.paramsUI.selectedDate = '';
    window.objOSGlobal.requestBodyValues.ScheduleID = '';
    window.objOSGlobal.requestBodyValues.ServiceText = $('#conceptCode').val() == 'MLY' ? "Lead Only" : "";
    }